export default __webpack_public_path__ + "static/media/paragraph.d8ebe63f.svg";